import { render, staticRenderFns } from "./manageTopic.vue?vue&type=template&id=47129fac&scoped=true"
import script from "./manageTopic.vue?vue&type=script&lang=js"
export * from "./manageTopic.vue?vue&type=script&lang=js"
import style0 from "./manageTopic.vue?vue&type=style&index=0&id=47129fac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47129fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47129fac')) {
      api.createRecord('47129fac', component.options)
    } else {
      api.reload('47129fac', component.options)
    }
    module.hot.accept("./manageTopic.vue?vue&type=template&id=47129fac&scoped=true", function () {
      api.rerender('47129fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/exam-manage/manageTopic.vue"
export default component.exports